import { render, staticRenderFns } from "./TemplateSearch.vue?vue&type=template&id=44d9973e&"
import script from "./TemplateSearch.vue?vue&type=script&lang=js&"
export * from "./TemplateSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports